import { Link, useRouteError } from "react-router-dom";
import { useState, useEffect } from "react";

// layout
import ErrorLayout from "layouts/ErrorLayout/ErrorLayout";

// components
import Blob from "components/icons/Blob";

// styles
import styles from "./Error.module.scss";

// assets
import Error500Image from "assets/images/error-spill.png";
import { FeedbackDialog } from "components/Dialogs";

export default function Error() {

  const [open, setOpen] = useState<boolean>(false);

  console.log("Error: ", useRouteError());

  const FeedbackLink = () => (
    <a
      className="usa-link"
      target="_blank"
      rel="noopener noreferrer"
      href="https://sbaone.atlassian.net/servicedesk/customer/portal/1016/group/1045/create/11743"
      aria-label="Give feedback"
    >
      Give feedback
    </a>
  )

  return (
    <ErrorLayout>
      <div className={styles["error-root"]}>
        <h1 className={styles["title"]}>500: Internal Server Error</h1>
        <h3 className={styles["sub-title"]}>
          Sorry, this is not working properly.
        </h3>

        <div className={styles["blob-content"]}>
          <Blob />
          <img src={Error500Image} alt="500" />
        </div>

        <div className={styles["group"]}>
          <div>
            <p className={styles["desc"]}>
            We know about this mistake and are working to fix it.
            <br/>
            In the meantime, here is what you can do:
            </p>
          </div>
          <div>
            <p><strong>Refresh the page</strong> (sometimes this helps)</p>
            <p><strong>Try again in 30 minutes</strong></p>
            <p>
              {/* <button
                type="button"
                className={styles["btn"]}
                onClick={() => setOpen(true)}
              >
                Give feedback
              </button> */}

            {<FeedbackLink />} and tell us what happened 
            </p>
          </div>
          <div>
            <Link to="/" className={styles["link"]}>Return home</Link>
          </div>

          {open && <FeedbackDialog open={open} setOpen={setOpen} />}
        </div>
      </div>
    </ErrorLayout>
  );
}
